import { useState } from "react";
import { X } from "lucide-react";

export default function Modal({ title, subtitle, onClose, children, size = "md" }) {
  const widths = { sm: 480, md: 640, lg: 880, xl: 1080 };
  return (
    <div
      className="fade-in"
      style={{ position: "fixed", inset: 0, background: "rgba(28,27,26,0.5)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={onClose}
      data-testid="modal-backdrop"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="card-ledger"
        style={{ width: "100%", maxWidth: widths[size], maxHeight: "92vh", display: "flex", flexDirection: "column", boxShadow: "0 24px 64px rgba(0,0,0,0.18)" }}
        data-testid="modal"
      >
        <div className="flex items-start justify-between px-6 py-4 divider-h">
          <div>
            <h2 className="font-display" style={{ fontSize: 18, fontWeight: 700, margin: 0, lineHeight: 1.2 }} data-testid="modal-title">{title}</h2>
            {subtitle && <div style={{ fontSize: 13, color: "var(--text-2)", marginTop: 2 }}>{subtitle}</div>}
          </div>
          <button onClick={onClose} className="btn-ghost" style={{ padding: 6 }} data-testid="modal-close">
            <X size={18} />
          </button>
        </div>
        <div style={{ overflowY: "auto", padding: 24 }}>{children}</div>
      </div>
    </div>
  );
}
